import { DeleteOutlined } from '@ant-design/icons';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Namespace } from '@data/utils/enums';
import { AntdModal, AntdTooltip, AntdTypography, Button } from '@ui/components';
import { useDeleteQuestion } from './hooks';

const { Text } = AntdTypography;

export const DeleteQuestion = () => {
  const { t } = useTranslation([Namespace.ADMIN]);
  const {
    isLoading,
    isPopupOpen,
    disabled,
    interactionLink,
    openPopup,
    closePopup,
    deleteQuestion,
    handleButtonHover,
  } = useDeleteQuestion();

  return (
    <>
      <div className="inline-block px-16 py-8 -mx-16 -my-8" onMouseEnter={handleButtonHover}>
        <AntdTooltip
          title={
            disabled && (
              <Trans
                t={t}
                i18nKey={`question_page.delete_question.tooltips.${disabled}`}
                components={[
                  <Link key="link" to={interactionLink} className="text-white underline" />,
                ]}
              />
            )
          }
          placement="bottomRight"
        >
          <Button
            icon={<DeleteOutlined />}
            disabled={!!disabled || isLoading}
            className="text-error relative z-10"
            type="text"
            onClick={openPopup}
            data-testid="delete-question-button"
          >
            {t('question_page.delete_question.title')}
          </Button>
        </AntdTooltip>
      </div>

      <AntdModal
        open={isPopupOpen}
        title={t('question_page.delete_question.title')}
        okText={t('question_page.delete_question.button')}
        okButtonProps={{
          danger: true,
          loading: isLoading,
          'data-testid': 'delete-question-confirm-button',
        }}
        cancelButtonProps={{ disabled: isLoading }}
        onCancel={closePopup}
        onOk={deleteQuestion}
        className="p-4"
        closeIcon={null}
      >
        <Text>{t('question_page.delete_question.popup')}</Text>
      </AntdModal>
    </>
  );
};
